module.exports = __webpack_public_path__ + "img/jihui.8b335298.png";